<template>
    <div class="tags" id="tags">
        <ul class="tags-ul" id="tags-ul">
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item)}" :key="index" @click="showItem(item,index)">
                <span class="tags-li-title">{{ item.name }}</span>
                <el-icon class="tags-li-icon" @click.stop="closeTab(index)"><Close /></el-icon>
                <div class="tag-dot"></div>
            </li>
        </ul>
        <div class="tags-close-box">
            <div class="add-tab-button" @click="testAddTages" v-if="false">
                <el-icon><CirclePlus /></el-icon>
            </div>
            <el-dropdown @command="handMenu">
                <div class="tags-action-button">
                    <el-icon><ArrowDown /></el-icon>
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="closeOther">关闭其他</el-dropdown-item>
                        <el-dropdown-item command="closeAll">关闭所有</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import {Base64} from 'js-base64'
import {Close,CirclePlus,ArrowDown} from '@element-plus/icons-vue'
export default {
    components:{
        Close,CirclePlus,ArrowDown
    },
    data:function(){
        return {
           tagsList:[
                
           ], 
           tagLiStyle:""     // tab的文字样式
        }
    },
    methods:{
        isActive(item) {   
            return item.id == this.$route.meta.id;
        }, 
        //关闭其他说着关闭所有
        handMenu(command){
            if(command == 'closeOther'){
                const curItem = this.tagsList.filter(item => { 
                    return item.id == this.$route.meta.id;
                })
                this.tagsList = curItem;
                this.changeTabSize(0);
            }else if(command == 'closeAll'){
                if(this.tagsList.length == 1 && this.tagsList[0].name == "控制台"){
                    return;
                }
                
                this.tagsList = [];
                this.$router.push('/console');
                this.changeTabSize(0);
            }
        },
        //点击tab,显示当前的
        showItem(item,index){
            this.$router.push({
                path:item.id,
                meta:{keepAlive:true}
            });
            // this.$emit('tags', this.tagsList);
            // this.changeTabSize(index);
        },
        //关闭单个
        closeTab(index){
            //最后的索引
            let lastIndex = this.tagsList.length - 1;
            if(lastIndex == 0){
                if(this.tagsList[0].name == "控制台"){
                    return;
                }
                this.tagsList = [];
                this.$router.push({path:'/console'});
                // this.$emit('tags', this.tagsList);
                this.changeTabSize(0);
                return;
            }
            //要删除的menu
            let delItem = this.tagsList[index];
            //不是当前显示的
            if(!this.isActive(delItem)){
                this.tagsList.splice(index,1);
                // this.$emit('tags', this.tagsList);
                this.changeTabSize(index);
                return;
            } 

            //获取下一个要显示的
            let nextItem = null;
            if(index < lastIndex) nextItem = this.tagsList[index + 1];
            else nextItem = this.tagsList[index - 1];
             
            //显示需要显示的
            this.$router.push({
                path:nextItem.id
            });
            //删除在显示的
            this.tagsList.splice(index,1);
             
            // this.$emit('tags', this.tagsList);
            this.changeTabSize(index);
        },
        // 设置标签
        setTags(route){
            // const isExist = this.tagsList.some(item => { 
            //     return item.id == route.meta.id;
            // })
            let index = -1;
            for(let i = 0;i<this.tagsList.length;i++){
                if(this.tagsList[i].id == route.meta.id){
                    index = i;
                    break;
                }
            }
            if(index == -1){  
                let item = {
                    id:route.meta.id,
                    name:route.meta.name,
                    url:route.meta.url
                };
                this.tagsList.push(item);
            }
            // this.$emit('tags', this.tagsList); 
            this.changeTabSize(index);
        },
        //调整tab的大小,index 0第一个，-1最后一个
        changeTabSize(index){
            let tabList = document.getElementById("tab-list");
            if(tabList == null) return;
            let clientWidth = tabList.clientWidth;
            let showNum = (clientWidth + 86 - 1) / 86;
            let num = this.tagsList.length;

            this.$nextTick(()=>{
                if(index == -1 || index >= num - showNum / 3 ){
                    tabList.scrollLeft = clientWidth;
                }else if(index == 0 || index <= showNum / 3){
                    tabList.scrollLeft = 0;
                }else{ 
                    tabList.scrollLeft = clientWidth / num * index;
                }
            }); 
        }
    },
    watch:{
        $route(newValue){ 
            if(newValue.meta.level == 1){ 
                this.setTags(newValue);
            }
        }
    },
    created(){ 
        //刷新的时候保留当前的
        if(this.$route.meta.level == 1){ 
            this.setTags(this.$route); 
        } 
    }
}
</script>
<style scoped>
.tags {
    height: 65px;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #EBEEF5;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 10;
}

.tags-ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 15px;
    padding-left: 0;
    list-style: none;
    flex: 1;
    overflow-x: auto;
    height: 100%;
    /* scrollbar-width: thin; */
    white-space: nowrap;
}

/* 隐藏滚动条但保留功能 */
.tags-ul::-webkit-scrollbar {
    height: 3px;
}

.tags-ul::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
}

.tags-li {
    display: inline-flex;
    align-items: center;
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    background-color: #FFFFFF;
    border-radius: 4px;
    color: #606266;
    font-size: 13px;
    margin-right: 6px;
    cursor: pointer;
    user-select: none;
    border: 1px solid rgba(65, 112, 255, 0.3);
    transition: all 0.3s;
    position: relative;
    white-space: nowrap;
    margin-left: 10px;
}

.tags-li:hover {
    background-color: #F0F9FF;
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.tags-li.active {
    color: #4170FF;
    background-color: rgba(65, 112, 255, 0.08);
    border-color: rgba(65, 112, 255, 0.8);
    font-weight: 500;
}

.tags-li-title {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tags-li-icon {
    margin-left: 6px;
    color: #909399;
    font-size: 14px;
    width: 14px;
    height: 14px;
    text-align: center;
    line-height: 14px;
    border-radius: 50%;
    transition: all 0.3s;
}

.tags-li-icon:hover {
    color: #F56C6C;
    background-color: rgba(245, 108, 108, 0.1);
    transform: scale(1.2);
}

.tags-close-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
}

.tags-close-box .el-dropdown {
    margin-left: 8px;
}

.tag-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #4170FF;
    position: absolute;
    left: 7px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
}

.tags-li.active .tag-dot {
    display: block;
}

/* 添加新标签按钮 */
.add-tab-button {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: transparent;
    color: #909399;
    cursor: pointer;
    transition: all 0.3s;
    margin-left: 8px;
}

.add-tab-button:hover {
    background-color: rgba(65, 112, 255, 0.1);
    color: #4170FF;
    transform: rotate(90deg);
}

/* 标签栏更多操作按钮 */
.tags-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #909399;
    cursor: pointer;
    transition: all 0.3s;
}

.tags-action-button:hover {
    background-color: rgba(65, 112, 255, 0.1);
    color: #4170FF;
}

/* 标签间细微分隔线 */
.tags-li:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -3px;
    top: 6px;
    bottom: 6px;
    width: 1px;
    background-color: #EBEEF5;
    z-index: 1;
}

/* 调整下拉菜单项宽度和文字处理 */
:deep(.el-dropdown-menu__item) {
    padding: 12px 20px !important;
    font-size: 14px !important;
    font-weight: 500;
    color: #303133;
    line-height: 1.4;
    white-space: normal !important;
    word-break: break-word !important;
    min-width: 120px !important;
    max-width: 240px !important;
    width: auto !important;
    margin: 0 !important;
    border-bottom: 1px solid #EBEEF5;
}

/* 最后一个菜单项不需要边框 */
:deep(.el-dropdown-menu__item:last-child) {
    border-bottom: none;
}

/* 调整下拉菜单整体尺寸 */
:deep(.el-dropdown-menu) {
    min-width: 140px !important;
    max-width: 240px !important;
    width: auto !important;
    padding: 6px 0 !important;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>
